module.exports = "<span ng-click=$ctrl.showCalculator($event)>Calculadora de precios</span> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/tsz-price-calculator/tsz-price-calculator.html
// module id = 138
// module chunks = 1